import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import {HOST} from "@/config/index";
const zygstBol = window.location.href.indexOf('hbgszyht')>-1
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    meta: { title:zygstBol? '中油高速通': 'G7能源商户端'},
    component: resolve => require(['@/views/Index.vue'], resolve)
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录'},
    component: resolve => require(['@/views/Login.vue'], resolve)
  },
  {
    path: '/mine',
    name: 'mine',
    meta: { title: '账号设置'},
    component: resolve => require(['@/views/Mine.vue'], resolve)
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    meta: { title: '修改密码'},
    component: resolve => require(['@/views/ChangePwd.vue'], resolve)
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: { title: '隐私协议'},
    component: resolve => require(['@/views/privacy.vue'], resolve)
  },
  {
    path: '/privacySummary',
    name: 'privacySummary',
    meta: { title: '隐私政策摘要'},
    component: resolve => require(['@/views/privacySummary.vue'], resolve)
  },
  {
    path: '/privacyCollect',
    name: 'privacyCollect',
    meta: { title: '个人信息收集清单'},
    component: resolve => require(['@/views/privacyCollect.vue'], resolve)
  },
  {
    path: '/protocol',
    name: 'protocol',
    meta: { title: '用户协议'},
    component: resolve => require(['@/views/protocol.vue'], resolve)
  },
  {
    path: '/voice',
    name: 'voice',
    meta: { title: '语音播报'},
    component: resolve => require(['@/views/Voice.vue'], resolve)
  },
  {
      path: '/print',
      name: 'print',
      meta: { title: '打印设置'},
      component: resolve => require(['@/views/Print.vue'], resolve)
  },
  {
    path: '/wxBind',
    name: 'wxBind',
    meta: { title: '微信绑定'},
    component: resolve => require(['@/views/WxBind.vue'], resolve)
  },
  {
    path: '/scanError',
    name: 'scanError',
    meta: { title: '二维码验证失败'},
    component: resolve => require(['@/views/ScanError.vue'], resolve)
  },
  {
    path: '/charge',
    name: 'charge',
    meta: { title: '收费'},
    component: resolve => require(['@/views/Charge.vue'], resolve)
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: resolve => require(['@/views/OrderList.vue'], resolve),
    meta: { title: '订单列表', keepalive: true}
  },
  {
    path: '/CooperativeOrderList',
    name: 'CooperativeOrderList',
    component: resolve => require(['@/views/CooperativeOrderList.vue'], resolve),
    meta: { title: '订单列表', keepalive: true}
  },
    {
        path: '/historyList',
        name: 'historyList',
        component: resolve => require(['@/views/HistoryList.vue'], resolve),
        meta: { title: '历史流水查询'}
    },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: resolve => require(['@/views/OrderDetail.vue'], resolve),
    meta: { title: '订单详情'}
  },
  {
    path: '/CooperativeOrderDetail',
    name: 'CooperativeOrderDetail',
    component: resolve => require(['@/views/CooperativeOrderDetail.vue'], resolve),
    meta: { title: '订单详情'}
  },
  {
    path: '/PaymentCollection',
    name: 'PaymentCollection',
    component: resolve => require(['@/views/PaymentCollection.vue'], resolve),
    meta: { title: '收款'}
  },
  {
    path: '/tradeCancel',
    name: 'tradeCancel',
    component: resolve => require(['@/views/TradeCancel.vue'], resolve),
    meta: { title: '交易撤销'}
  },
  {
    path: '/cancelApply',
    name: 'cancelApply',
    component: resolve => require(['@/views/CancelApply.vue'], resolve),
    meta: { title: '撤销申请成功'}
  },
  {
    path: '/changeOilPrice',
    name: 'changeOilPrice',
    component: resolve => require(['@/views/ChangeOilPrice.vue'], resolve),
    meta: { title: '油价变更'}
  },
  {
    path: '/stationDetail',
    name: 'StationDetail',
    component: resolve => require(['@/views/StationDetail.vue'], resolve),
    meta: { title: '站点详情'}
  },
  {
    path: '/stationDetailConfirm',
    name: 'StationDetailConfirm',
    component: resolve => require(['@/views/StationDetailConfirm.vue'], resolve),
    meta: { title: '我要调价'}
  }
]


const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach( (to, from, next) => {
 if(to.meta.title) {
     native.initTopbar(JSON.stringify({
         title: to.meta.title,
     }));
 }
    next();
})
router.afterEach(async (to, from) => {

  if (window.__wxjs_is_wkwebview) {
    // IOS 记录首次进入url
    console.log('苹果');
    if (window.entryUrl === '' || typeof window.entryUrl === undefined) {
      //var url = encodeURIComponent(`${HOST}${to.fullPath}`)
      var url = location.href.split('#')[0]
      window.entryUrl = url
    }
  }
})
export default router
